import omniRegionsFollowing from './reducers';

import * as omniRegionsFollowingOperations from './operations';
import * as omniRegionsFollowingTypes from './types';
import * as omniRegionsFollowingAction from './actions';

export { omniRegionsFollowingOperations, omniRegionsFollowingTypes, omniRegionsFollowingAction };

export default omniRegionsFollowing;
